/*
 * Public API Surface of ngx-lib/core/layout
 */
export * from './layout.service';
export * from './rtl.directive';
